<template>
    <div id="leahu_academy" class="container-fluid  custom-container my-5">

        <div class="d-flex flex-row flex-wrap w-100 justify-content-center mt-5 text-center">
            <h2 class="d-flex flex-row flex-wrap justify-content-center text-center">
                <span class="pr-2">Academia Spațială</span>
                <span class="d-flex flex-row flex-no-wrap">
                    Dr. Leahu
                </span>
            </h2>
        </div>

        <div class="d-flex flex-lg-row flex-column pt-5 pt-lg-3" id="section_1">
            <div class="d-flex flex-column custom-width-sections ml-lg-auto  my-auto">
                <h2 class="">Clinica stomatologică pentru micii exploratori</h2>
                <p class="pt-3">
                    Copiii care îl îndrăgesc pe micuțul dințișor aventuros Tuti au acum un loc special creat pentru
                    ei.
                </p>
                <p>
                    Aici ne distrăm, învățăm despre sănătatea dinților și suntem îngrijiți de personal medical
                    profesionist și cu experiență în interacțiunea cu copiii.
                </p>
                <p>
                    Este un loc magic unde joaca se întâlnește cu tehnicile de ultimă generație de îngrijire dentară.
                </p>
            </div>
            <div class="my-auto img-parent">
                <img src="../../assets/imgs/landing/section-1.png" alt="" class="img-fluid">

                <img src="../../assets/imgs/landing/section-1-dintica.png" alt=""
                     class="img-fluid animate trigger"
                     id="section-1-dintica">
                <img src="../../assets/imgs/landing/section-1-nava.png" alt="" class="img-fluid animate"
                     id="section-1-nava">
            </div>
        </div>

        <div class="d-flex flex-lg-row flex-column pt-5 pt-lg-3" id="section_2">
            <div class="order-2 order-lg-1 my-auto img-parent" id="animate-scroll">
                <img src="../../assets/imgs/landing/section-2.png" alt="" class="img-fluid">

                <img src="../../assets/imgs/landing/section-2-pins.png" alt="" class="img-fluid animate"
                     id="section-2-pins">
            </div>
            <div class="d-flex flex-column order-1 order-lg-2 custom-width-sections my-auto pl-lg-4">
                <!--<h2>-->
                <!--Academia Spațială Dr. Leahu deschide drumuri noi spre distracție-->
                <!--</h2>-->

                <h2 class="d-flex flex-row flex-wrap">
                    <span class="pr-2">Academia Spațială</span>
                    <span class="d-flex flex-row flex-no-wrap pr-2">
                        Dr. Leahu</span>
                    <span>deschide drumuri noi spre distracție</span>
                </h2>

                <p class="pt-3">
                    Ești așteptat într-un loc plin de aventură, unde distracția te însoțește la fiecare pas: avem
                    jocuri digitale create special de noi pentru a amuza și pentru a educa despre îngrijirea corectă a
                    dinților, insigne de colecționat pentru a-ți arăta experiență și cunoștințele, și chiar și faimosul
                    EXPLORATRON, simulatorul unde controlezi jocuri cu tot corpul, imitând zborul prin spațiu și alte
                    experiențe frumoase.
                </p>

                <div class="icons">
                    <div class="d-flex flex-row my-2">
                        <div>
                            <img src="../../assets/imgs/landing/icon-jocuri-digitale-cu-clasament.png" alt=""
                                 class="">
                        </div>
                        <h6 class="my-auto pl-2">
                            Jocuri digitale cu clasament
                        </h6>
                    </div>
                    <div class="d-flex flex-row my-2">
                        <div>
                            <img src="../../assets/imgs/landing/icon-insigne-si-cadouri.png" alt="" class="">
                        </div>
                        <h6 class="my-auto pl-2">
                            Insigne și cadouri
                        </h6>
                    </div>
                    <div class="d-flex flex-row my-2">
                        <div>
                            <img src="../../assets/imgs/landing/icon-simulatorul-exploratron.png" alt=""
                                 class="">
                        </div>
                        <h6 class="my-auto pl-2">
                            Simulatorul EXPLORATRON
                        </h6>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-lg-row flex-column pt-5 pt-lg-3" id="section_3">
            <div class="d-flex flex-column custom-width-sections ml-lg-auto my-auto">
                <h2>
                    Echipa lui Tuti
                </h2>
                <p class="pt-3">
                    Credem că vizita la stomatolog poate să fie o experiență fermecătoare, nu înspăimântătoare.
                </p>
                <p>
                    De aceea am adus sub același acoperiș un colectiv divers de medici pedodonți prietenoși și personal
                    specializat, pregătit pentru intervenții și tratamente la cel mai înalt nivel de profesionalism,
                    folosind aparatură și abordări de ultimă generație.
                </p>
                <p>
                    În Academia Spațială Dr. Leahu, copiii se simt auziți și tratați cu respect, iar acest aspect
                    esențial este ceea ce transformă vizita la dentist într-o amintire frumoasă. Este un loc unde copiii
                    vor vrea să revină.
                </p>
            </div>
            <div class="my-auto img-parent">
                <img src="../../assets/imgs/landing/section-3.png" alt="" class="img-fluid">

                <img src="../../assets/imgs/landing/section-3-dintica.png" alt="" class="img-fluid animate"
                     id="section-3-dintica">
            </div>
        </div>
    </div>
</template>

<script>
    import anime from 'animejs/lib/anime.js';

    export default {
        name: "LeahuAcademy",
        mounted() {

            anime({
                targets: '#section-1-dintica',
                direction: 'alternate',
                translateY: [50, 10],
                translateX: 10,
                duration: 4000,
                easing: 'linear',
                loop: true
            });

            anime({
                targets: '#section-1-nava',
                direction: 'alternate',
                translateX: [-10, 10],
                translateY: 10,
                duration: 4000,
                easing: 'linear',
                loop: true
            });

            anime({
                targets: '#section-3-dintica',
                direction: 'alternate',
                translateY: [0, 30],
                translateX: 10,
                duration: 4000,
                easing: 'linear',
                loop: true
            });

            const $ = window.$;
            let scrollableElement = $('#section-2-pins');
            var vertical_position = 5;
            var lastScrollTop = 0;
            var scrollValue = 0.2;
            var maxScroll = 13;
            var minScroll = 0;
            if ($(window).innerWidth < 767) {
                scrollValue = 0.1;
                maxScroll = 10;
            }

            $(window).on('scroll', function () {
                try{
                    var element_position = $('.trigger').offset().top;
                    var y_scroll_pos = window.pageYOffset;
                    var scroll_pos_test = element_position;

                    if (y_scroll_pos > scroll_pos_test) {

                        var st = window.pageYOffset || document.documentElement.scrollTop;
                        if (vertical_position > minScroll && vertical_position < maxScroll) {
                            if (st > lastScrollTop) {
                                vertical_position = vertical_position < (maxScroll - 0.5) ? vertical_position + scrollValue : vertical_position;
                                scrollableElement.css("top", vertical_position + '%');
                            } else {
                                vertical_position = vertical_position > (minScroll + 0.5) ? vertical_position - scrollValue : vertical_position;
                                scrollableElement.css("top", vertical_position + '%');
                            }
                        }
                        lastScrollTop = st <= 0 ? 0 : st;


                    }
                } catch (error) {
                    console.log('error', error);
                }

            });
        }

    }
</script>

<style scoped>

</style>
